// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  overflow-x: hidden;
  font-family: "Poppins", sans-serif;
}

table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

th,
td {
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}

thead tr th {
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: #ffffff;
}

input[type=date] {
  margin: 1vh;
  font-family: "Poppins", sans-serif;
  font-size: 18.5px;
  width: 12.4vh;
  height: 3.1vh;
  border-radius: 4px;
  background-color: #f1f1f1;
}

h4 {
  text-align: center;
}

.range {
  -webkit-appearance: slider-vertical;
}

.danger {
  height: 30%;
  margin-top: 100%;
}

.success {
  height: 25%;
}

.warning {
  height: 15%;
}

.dropbtn {
  border-radius: 4px;
  background-color: #4CAF50;
  font-family: "Poppins", sans-serif;
  font-size: 17px;
  color: #f9f9f9;
  padding: 10px;
  margin: 10px;
  width: 100%;
  height: 3.8vh;
  border: none;
  cursor: pointer;
}

.dropOption {
  color: black;
  background: #f9f9f9;
  font-size: 14px;
  width: 90%;
  margin: 10px;
  border: none;
  cursor: pointer;
}

.dropdown {
  position: relative;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f9f9f9;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
}

.dropdown-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

.dropdown-content a:hover {
  background-color: #f1f1f1
}

.dropdown:hover .dropdown-content {
  display: block;
}

.dropdown:hover .dropbtn {
  background-color: #3e8e41;
}

.container {
  display: flex;
  justify-content: center;
  height: 60vh;
  align-items: center;
}

.logout {
  margin-left: 25%;
  border-radius: 4px;
  background-color: white;
  font-family: "Poppins", sans-serif;
  font-size: 15px;
  color: black;
  padding: 10px;
  width: 140px;
  height: 3.8vh;
  border: 0.5px solid black
}

.lineChart {
  height: 50000px;
}

.options-container {
  margin-left: 25%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.table-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.table-card {
  overflow: scroll;
  background-color: var(--white-text);
  border-radius: 1rem;
  box-shadow: 0 1rem 1rem rgba(0, 0, 0, 0.2);
  margin: 1rem;
  height: 15rem;
}

.left-column {
  color: var(--white-text);
  max-width: 5rem;
  margin-top: 10vh;
  margin-bottom: 8.6vh;
  margin-left: 5vh;
  display: flex;
  flex-direction: column;
}

.right-column {
  width: 100%;
  margin-left: 1vh;
}

.card {
  background-color: var(--white-text);
  border-radius: 1rem;
  display: flex;
  box-shadow: 0.5rem 0rem 1rem rgba(0, 0, 0, 0.2);
  margin: 0.5rem;
  overflow: hidden;
  height: 36rem;
}

select {
  width: 18vh;
  font-family: "Poppins", sans-serif;
  font-size: 19px;
  height: 3.6vh;
  border-radius: 4px;
  background-color: #f1f1f1;
}

@media (max-width: 1602px) {
  .options-container {
    margin-left: -5%;
  }

  .left-column {
    margin-top: 10vh;
    margin-bottom: 10vh;
  }

  .card {
    background-color: var(--white-text);
    border-radius: 1rem;
    box-shadow: 0 1rem 1rem rgba(0, 0, 0, 0.2);
    margin: 2rem;
    overflow: hidden;
    width: 100%;
    height: 30rem;
  }
}

@media (max-width: 1030px) {
  .left-column {
    margin-bottom: 12vh;
  }

  .logout {
    margin-left: 10%;
    border-radius: 4px;
    background-color: white;
    font-family: "Poppins", sans-serif;
    font-size: 14px;
    color: black;
    width: 15vh;
    height: 3.8vh;
    border: 0.5px solid black
  }

  input[type=date] {
    width: 15vh;
  }

  .options-container {
    margin-left: 1%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .container {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: auto;
  }

  .card {
    background-color: var(--white-text);
    border-radius: 1rem;
    box-shadow: 0 1rem 1rem rgba(0, 0, 0, 0.2);
    margin: 2rem;
    overflow: hidden;
    width: 100%;
    height: 40rem;
  }
}

@media (max-width: 830px) {
  .container {
    margin-top: 3%;
    display: flex;
    justify-content: center;
    height: 110vh;
    align-items: center;
  }

  .left-column {
    margin-bottom: 6.5vh;
  }

  .logout {
    margin-left: 2%;
    border-radius: 4px;
    background-color: white;
    font-family: "Poppins", sans-serif;
    font-size: 12px;
    color: black;
    width: 15vh;
    height: 3.8vh;
    border: 0.5px solid black
  }

  .card {
    background-color: var(--white-text);
    border-radius: 1rem;
    box-shadow: 0 1rem 1rem rgba(0, 0, 0, 0.2);
    margin: 2rem;
    overflow: hidden;
    width: 100%;
    height: 50rem;
  }
}

@media (max-width: 420px) {
  .container {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: auto;
  }

  .options-container {
    flex-direction: column;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .card {
    background-color: var(--white-text);
    border-radius: 1rem;
    box-shadow: 0 1rem 1rem rgba(0, 0, 0, 0.2);
    margin: 2rem;
    overflow: hidden;
    width: 100%;
    height: 19rem;
  }

  .left-column {
    color: var(--white-text);
    height: 20vh;
    margin-top: 11vh;
    margin-left: 1%;
    display: flex;
    flex-direction: column;
  }

  .right-column {
    width: 100%;
    margin-left: -1vh;
  }

}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAGA;EACE,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kCAAkC;EAClC,iBAAiB;EACjB,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kCAAkC;EAClC,eAAe;EACf,cAAc;EACd,aAAa;EACb,YAAY;EACZ,WAAW;EACX,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,+CAA+C;EAC/C,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,aAAa;EACb;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,mBAAmB;EACnB,0CAA0C;EAC1C,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,aAAa;EACb,+CAA+C;EAC/C,cAAc;EACd,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kCAAkC;EAClC,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,mCAAmC;IACnC,mBAAmB;IACnB,0CAA0C;IAC1C,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,aAAa;EACf;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;IACvB,kCAAkC;IAClC,eAAe;IACf,YAAY;IACZ,WAAW;IACX,aAAa;IACb;EACF;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,mCAAmC;IACnC,mBAAmB;IACnB,0CAA0C;IAC1C,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,aAAa;EACf;AACF;;AAEA;EACE;IACE,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,uBAAuB;IACvB,kCAAkC;IAClC,eAAe;IACf,YAAY;IACZ,WAAW;IACX,aAAa;IACb;EACF;;EAEA;IACE,mCAAmC;IACnC,mBAAmB;IACnB,0CAA0C;IAC1C,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,aAAa;EACf;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,mCAAmC;IACnC,mBAAmB;IACnB,0CAA0C;IAC1C,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,aAAa;EACf;;EAEA;IACE,wBAAwB;IACxB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,iBAAiB;EACnB;;AAEF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600&display=swap\");\n\n\nbody {\n  overflow-x: hidden;\n  font-family: \"Poppins\", sans-serif;\n}\n\ntable {\n  width: 100%;\n  border-collapse: collapse;\n  table-layout: fixed;\n}\n\nth,\ntd {\n  overflow: hidden;\n  text-align: center;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\nthead tr th {\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  background-color: #ffffff;\n}\n\ninput[type=date] {\n  margin: 1vh;\n  font-family: \"Poppins\", sans-serif;\n  font-size: 18.5px;\n  width: 12.4vh;\n  height: 3.1vh;\n  border-radius: 4px;\n  background-color: #f1f1f1;\n}\n\nh4 {\n  text-align: center;\n}\n\n.range {\n  -webkit-appearance: slider-vertical;\n}\n\n.danger {\n  height: 30%;\n  margin-top: 100%;\n}\n\n.success {\n  height: 25%;\n}\n\n.warning {\n  height: 15%;\n}\n\n.dropbtn {\n  border-radius: 4px;\n  background-color: #4CAF50;\n  font-family: \"Poppins\", sans-serif;\n  font-size: 17px;\n  color: #f9f9f9;\n  padding: 10px;\n  margin: 10px;\n  width: 100%;\n  height: 3.8vh;\n  border: none;\n  cursor: pointer;\n}\n\n.dropOption {\n  color: black;\n  background: #f9f9f9;\n  font-size: 14px;\n  width: 90%;\n  margin: 10px;\n  border: none;\n  cursor: pointer;\n}\n\n.dropdown {\n  position: relative;\n}\n\n.dropdown-content {\n  display: none;\n  position: absolute;\n  background-color: #f9f9f9;\n  min-width: 160px;\n  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);\n  z-index: 1;\n}\n\n.dropdown-content a {\n  color: black;\n  padding: 12px 16px;\n  text-decoration: none;\n  display: block;\n}\n\n.dropdown-content a:hover {\n  background-color: #f1f1f1\n}\n\n.dropdown:hover .dropdown-content {\n  display: block;\n}\n\n.dropdown:hover .dropbtn {\n  background-color: #3e8e41;\n}\n\n.container {\n  display: flex;\n  justify-content: center;\n  height: 60vh;\n  align-items: center;\n}\n\n.logout {\n  margin-left: 25%;\n  border-radius: 4px;\n  background-color: white;\n  font-family: \"Poppins\", sans-serif;\n  font-size: 15px;\n  color: black;\n  padding: 10px;\n  width: 140px;\n  height: 3.8vh;\n  border: 0.5px solid black\n}\n\n.lineChart {\n  height: 50000px;\n}\n\n.options-container {\n  margin-left: 25%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.table-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.table-card {\n  overflow: scroll;\n  background-color: var(--white-text);\n  border-radius: 1rem;\n  box-shadow: 0 1rem 1rem rgba(0, 0, 0, 0.2);\n  margin: 1rem;\n  height: 15rem;\n}\n\n.left-column {\n  color: var(--white-text);\n  max-width: 5rem;\n  margin-top: 10vh;\n  margin-bottom: 8.6vh;\n  margin-left: 5vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.right-column {\n  width: 100%;\n  margin-left: 1vh;\n}\n\n.card {\n  background-color: var(--white-text);\n  border-radius: 1rem;\n  display: flex;\n  box-shadow: 0.5rem 0rem 1rem rgba(0, 0, 0, 0.2);\n  margin: 0.5rem;\n  overflow: hidden;\n  height: 36rem;\n}\n\nselect {\n  width: 18vh;\n  font-family: \"Poppins\", sans-serif;\n  font-size: 19px;\n  height: 3.6vh;\n  border-radius: 4px;\n  background-color: #f1f1f1;\n}\n\n@media (max-width: 1602px) {\n  .options-container {\n    margin-left: -5%;\n  }\n\n  .left-column {\n    margin-top: 10vh;\n    margin-bottom: 10vh;\n  }\n\n  .card {\n    background-color: var(--white-text);\n    border-radius: 1rem;\n    box-shadow: 0 1rem 1rem rgba(0, 0, 0, 0.2);\n    margin: 2rem;\n    overflow: hidden;\n    width: 100%;\n    height: 30rem;\n  }\n}\n\n@media (max-width: 1030px) {\n  .left-column {\n    margin-bottom: 12vh;\n  }\n\n  .logout {\n    margin-left: 10%;\n    border-radius: 4px;\n    background-color: white;\n    font-family: \"Poppins\", sans-serif;\n    font-size: 14px;\n    color: black;\n    width: 15vh;\n    height: 3.8vh;\n    border: 0.5px solid black\n  }\n\n  input[type=date] {\n    width: 15vh;\n  }\n\n  .options-container {\n    margin-left: 1%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .container {\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    height: auto;\n  }\n\n  .card {\n    background-color: var(--white-text);\n    border-radius: 1rem;\n    box-shadow: 0 1rem 1rem rgba(0, 0, 0, 0.2);\n    margin: 2rem;\n    overflow: hidden;\n    width: 100%;\n    height: 40rem;\n  }\n}\n\n@media (max-width: 830px) {\n  .container {\n    margin-top: 3%;\n    display: flex;\n    justify-content: center;\n    height: 110vh;\n    align-items: center;\n  }\n\n  .left-column {\n    margin-bottom: 6.5vh;\n  }\n\n  .logout {\n    margin-left: 2%;\n    border-radius: 4px;\n    background-color: white;\n    font-family: \"Poppins\", sans-serif;\n    font-size: 12px;\n    color: black;\n    width: 15vh;\n    height: 3.8vh;\n    border: 0.5px solid black\n  }\n\n  .card {\n    background-color: var(--white-text);\n    border-radius: 1rem;\n    box-shadow: 0 1rem 1rem rgba(0, 0, 0, 0.2);\n    margin: 2rem;\n    overflow: hidden;\n    width: 100%;\n    height: 50rem;\n  }\n}\n\n@media (max-width: 420px) {\n  .container {\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    height: auto;\n  }\n\n  .options-container {\n    flex-direction: column;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .card {\n    background-color: var(--white-text);\n    border-radius: 1rem;\n    box-shadow: 0 1rem 1rem rgba(0, 0, 0, 0.2);\n    margin: 2rem;\n    overflow: hidden;\n    width: 100%;\n    height: 19rem;\n  }\n\n  .left-column {\n    color: var(--white-text);\n    height: 20vh;\n    margin-top: 11vh;\n    margin-left: 1%;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .right-column {\n    width: 100%;\n    margin-left: -1vh;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
